<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout wrap>
      <v-flex
        xs12
        pt-1
        style="font-family: poppinssemibold; font-size: 22px"
        class="clr"
      >
        <h3>Add Product </h3>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 md6 lg3>
        <v-text-field
         
          :rules="[rules.required]"
          prepend-icon="mdi-food"
          v-model="CommonFields.name"
          label="Product Name *"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg3>
        <v-text-field
          readonly
         
          :rules="[rules.required]"
          prepend-icon="mdi-store"
          v-bind:value="$route.query.shop"
          label="Shop Name"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg3>
        <v-text-field
          type="number"
          prepend-icon="mdi-numeric"
          v-model="CommonFields.listingOrder"
          label="Order wise No."
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg3>
        <v-select
          ref="type"
          v-model="CommonFields.productType"
          :items="productTypes"
          :rules="[rules.required]"
          prepend-icon="mdi-food"
          color="#B1B1B1"
          hide-details=""
          placeholder="Product Type"
          label="Product Type *"
        ></v-select>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          ref="description"
          :rules="[rules.required]"
          prepend-icon="mdi-map-marker-outline"
          v-model="CommonFields.description"
          label="Brief Description"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg3>
        <v-select
          ref="category"
          v-model="CommonFields.categoryId"
          :items="categories"
          :rules="[rules.required]"
          prepend-icon="mdi-food"
          item-text="name"
          item-value="_id"
          color="#B1B1B1"
          hide-details=""
          placeholder="Product Categories"
          label="Product Category *"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6 lg3>
        <v-select
          v-model="CommonFields.allergens"
          :items="allergensList"
          :rules="[rules.required]"
          prepend-icon="mdi-food"
          color="#B1B1B1"
          multiple
          hide-details=""
          placeholder="Allergens"
          label="Allergens"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6 lg3 align-self-baseline pt-0 pt-md-7 pl-1>
        <v-checkbox
          :ripple="false"
          v-model="CommonFields.suitableForDiabetic"
          label="product is suitable for diabetic patient"
          color="#FEBD08"
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 md6 lg2 align-self-baseline pt-0 pt-md-7 pl-1>
        <v-checkbox
          :ripple="false"
          v-model="CommonFields.isAllTime"
          label="product is Available 24 x 7 *"
          color="#FEBD08"
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex
        v-if="!CommonFields.isAllTime"
        xs12
        text-left
        sm2
        lg1
        pl-3
        pt-3
        align-self-center
      >
        <v-dialog
          :retain-focus="false"
          v-model="addTimingDialog"
          persistent
          max-width="85%"
          :key="addTimingDialog"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              x-small
              :ripple="false"
              color="#FEBD08"
              v-bind="attrs"
              v-on="on"
              ><span style="color: #fff">Add Timing</span></v-btn
            >
          </template>
          <v-card>
            <v-form ref="addcat">
              <v-card-title>
                <span class="headline">Add Timing</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-row class="pl-2">
                        <span style="font-size: 18px"
                          >Please Select Avialable Days</span
                        >
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-checkbox
                            v-model="isEntireWeek"
                            @click="getWeek"
                            label="Entire Week"
                            color="warning"
                            :ripple="false"
                          >
                            <template v-slot:default>
                              <span
                                v-for="(item, index) in weekDays"
                                :key="index"
                              >
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col v-for="(item, index) in weekdays" :key="index">
                          <v-checkbox
                            @click="isEntireWeek = false"
                            v-model="availableDays"
                            :label="item"
                            :value="item"
                            color="warning"
                            :ripple="false"
                          >
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="text-left">
                      <span style="font-size: 18px"
                        >Please Select Available Timings</span
                      >
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pl-2">
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :open-on-click="true"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="startTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="startTime"
                            :rules="[rules.required]"
                            label="Starting Time"
                            prepend-icon="mdi-clock"
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu1"
                          v-model="startTime"
                          full-width
                          ampm-in-title
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu1 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu1.save(startTime)"
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pl-2">
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :open-on-click="true"
                        :nudge-right="40"
                        :return-value.sync="endTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="endTime"
                            :rules="[rules.required]"
                            prepend-icon="mdi-clock"
                            label="Ending Time"
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu2"
                          v-model="endTime"
                          full-width
                          ampm-in-title
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(endTime)"
                          >
                            OK
                          </v-btn></v-time-picker
                        >
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="addTimingDialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :disabled="
                    !startTime || !endTime || availableDays.length == 0
                  "
                  @click="addTiming()"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex xs12 sm12 pt-4>
        <v-layout wrap>
          <v-flex
            pb-3
            v-if="
              CommonFields.availableTimings &&
              CommonFields.availableTimings.length > 0 &&
              !CommonFields.isAllTime
            "
            xs12
            sm12
            md12
            pl-3
          >
            <v-card tile :elevation="1">
              <v-layout py-2 justify-start>
                <v-flex xs2 text-center>
                  <span style="color: #555d50"> Start Time </span>
                </v-flex>
                <v-flex xs2>
                  <span style="color: #555d50"> End Time </span>
                </v-flex>
                <v-flex xs5>
                  <span style="color: #555d50"> Days </span>
                </v-flex>
                <v-flex xs3 text-center>
                  <span style="color: #555d50"> Action </span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-divider></v-divider>
              </v-layout>

              <v-layout
                justify-center
                py-2
                v-for="(item, index) in CommonFields.availableTimings"
                :key="index"
              >
                <v-flex xs4 sm2 text-center>
                  <span style="color: #000">
                    {{ formatTime(item.start) }}
                  </span>
                </v-flex>
                <v-flex xs4 sm2>
                  <span style="color: #000">
                    {{ formatTime(item.end) }}
                  </span>
                </v-flex>
                <v-flex xs4 sm5>
                  <span
                    style="font-size: 14px"
                    v-for="(item1, index1) in item.availableDays"
                    :key="index1"
                  >
                    {{ item1 }}
                    <span v-if="index1 != item.availableDays.length - 1">
                      ,</span
                    >
                  </span>
                </v-flex>
                <v-flex xs4 sm3>
                  <v-btn
                    @click="CommonFields.availableTimings.splice(index, 1)"
                    color="red"
                    x-small
                    depressed
                    :ripple="false"
                  >
                    <span style="color: #fff"> Delete </span>
                  </v-btn>

                  <!-- <v-btn style="margin-left:6px"
                          color="green"
                          x-small
                          depressed
                          :ripple="false"
                        >
                          <span style="color: #fff"> Edit </span>
                        </v-btn> -->
                  <v-btn
                    style="margin-left: 5px"
                    x-small
                    :ripple="false"
                    color="green"
                    @click="openDialog(item.start, item.end, item, index)"
                    ><span style="color: #fff">Edit</span></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pt-3>
        <v-text-field
          ref="main ingredients"
          :rules="[rules.required]"
          prepend-icon="mdi-map-marker-outline"
          v-model="CommonFields.mingredients"
          label="main ingredients"
        >
        </v-text-field>
      </v-flex>
      <v-flex lg3>
        <v-text-field
          ref="preparationTime"
          :rules="[rules.required]"
          prepend-icon="mdi-clock"
          append-outer-icon="minutes"
          v-model="CommonFields.preparationTime"
          label="Preparation Time"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm4 lg3 pl-lg-10>
        <v-text-field
          ref="maxOrderQuantity"
          :rules="[rules.required]"
          prepend-icon="mdi-checkbox-intermediate"
          v-model="CommonFields.maxOrderQuantity"
          label="Maximum order quantity per customer"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm4 lg3 pl-3>
        <v-text-field
          type="number"
          prepend-icon="mdi-currency-inr"
          v-model="CommonFields.packingCharge"
          label="Packing Charge"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm4 lg3 pl-3 pt-5>
        <v-switch
          color="yellow"
          label=" Enable to Pre Order Only Product"
          v-model="CommonFields.preOrder"
        >
        </v-switch>
      </v-flex>

      <v-flex xs12 text-left>
        <span style="font-size: 20px; color: grey">Choose Food Type</span>
        <v-radio-group v-model="FOODTYPE" mandatory>
          <v-layout wrap>
            <v-flex xs6>
              <v-radio color="yellow" label="Food" value="FOOD"></v-radio
            ></v-flex>
            <v-flex xs6>
              <v-radio color="yellow" label="Meat" value="MEAT"></v-radio
            ></v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
      <v-flex xs12>
        <template v-if="FOODTYPE == 'FOOD'">
          <v-layout wrap>
            <v-flex xs12 text-left>
              <span style="font-size: 20px; color: grey"
                >Choose Food variant</span
              >
              <v-radio-group v-model="CategoryInFoods" mandatory>
                <v-layout wrap>
                  <v-flex xs4>
                    <v-radio color="yellow" label="Food" value="FOOD"></v-radio
                  ></v-flex>
                  <v-flex xs4>
                    <v-radio color="yellow" label="Cake" value="CAKE"></v-radio
                  ></v-flex>
                  <v-flex xs4>
                    <v-radio
                      color="yellow"
                      label="other type"
                      value="OTHER"
                    ></v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <FoodType
            :commonData="CommonFields"
            v-if="CategoryInFoods == 'FOOD'"
          />
          <CakeType
            :commonData="CommonFields"
            v-if="CategoryInFoods == 'CAKE'"
          />
          <OtherType
            :commonData="CommonFields"
            v-if="CategoryInFoods == 'OTHER'"
          />
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import FoodType from "./foodType";
import CakeType from "./cakeType";
import OtherType from "./otherType";

export default {
  components: {
    FoodType,
    CakeType,
    OtherType,
  },
  data() {
    return {
      full: true,
      half: false,
      qtr: false,
      portionProduct: false,
      //size
      appLoading: false,
      addTimingDialog: false,
      CommonFields: {
        preOrder: false,
        name: "",
        listingOrder: "",
        preparationTime: null,
        productType: "",
        description: "",
        categoryId: null,
        allergens: "",
        suitableForDiabetic: false,
        isAllTime: false,
        mingredients: "",
        availableTimings: [],
        maxOrderQuantity: null,
        packingCharge: 0,
      },
      EditTimingDialog: false,
      weekdays: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      availableDays: [],
      isEntireWeek: false,

      startTime: null,
      endTime: null,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      productTypes: [],
      categories: [],
      allergensList: [],
      FOODTYPE: "",
      CategoryInFoods: "",
      estart: null,
      eend: null,
      editingItem: {},

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        discount: (value) =>
          (value < 100 && value >= 0) || "Discount must be between 0-100",
        offerPrice: (value) => value >= 0 || "Offer price should be valid ",
      },
    };
  },

  mounted() {
    this.getProductTypes();
    this.getCategories();
    this.getAllergens();
  },
  methods: {
    getWeek() {
      if (this.isEntireWeek) this.availableDays = this.weekdays;
      if (this.isEntireWeek == false) this.availableDays = [];
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    openDialog(start, end, item, index) {
      this.estart = start;
      this.availableDays = item.availableDays;
      this.eend = end;
      this.editingItem = item;
      this.editingItem.index = index;
      this.estart = this.editingItem.start;
      this.eend = this.editingItem.end;
      this.EditTimingDialog = true;
    },

    addTiming() {
      this.CommonFields.availableTimings.push({
        start: this.startTime,
        end: this.endTime,
        availableDays: this.availableDays,
      });

      this.startTime = null;
      this.endTime = null;
      this.availableDays = [];
      this.addTimingDialog = false;
      this.isEntireWeek = false;
    },

    getProductTypes() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/type/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.productTypes = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
    getCategories() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/category/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.categories = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
    getAllergens() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/allergens/list",
      }).then((response) => {
        if (response.data.status) {
          this.allergensList = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
  },
};
</script>